<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">
    <div class="vx-navbar-wrapper">
      <vs-navbar class="vx-navbar navbar-custom" :color="navbarColor" :class="classObj">
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer mr-1" icon="MenuIcon" @click.stop="showSidebar"></feather-icon>

        <template v-if="breakpoint != 'md'">
          <div class="content-area__heading" :class="{'pr-4 border-0 md:border-r border-t-0 border-b-0 border-l-0 border-solid border-grey-light' : $route.meta.breadcrumb}">
            <h4 class="mb-1">{{ $route.meta.pageTitle }}</h4>
          </div>
          <vx-breadcrumb class="ml-4 md:block hidden v-step-6" v-if="$route.meta.breadcrumb" />
        </template>
        <vs-spacer></vs-spacer>

        <!-- SEARCHBAR -->
        <vx-tooltip text="Avvia il tour">
          <feather-icon icon="HelpCircleIcon" @click="toggleTour" class="cursor-pointer navbar-fuzzy-search ml-4"></feather-icon>
        </vx-tooltip>

        <!-- NOTIFICATIONS -->
        <vx-tooltip text="Notifiche">
          <Notifications :key="Math.random()"/>
        </vx-tooltip>

        <!-- USER META -->
        <div class="the-navbar__user-meta flex items-center">
          <div class="text-right leading-tight hidden sm:block v-step-4">
            <p class="font-semibold">{{ u_name }}</p>
            <small>{{ u_cognome }}</small>
          </div>
          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <div class="con-img ml-3">
              <vs-avatar color="primary" icon-pack="feather" icon="icon-user" />
            </div>
            <vs-dropdown-menu class="vx-navbar-dropdown myDropDown">
              <ul style="min-width: 9rem">
                <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="clickProfile"><feather-icon icon="UserIcon" svgClasses="w-4 h-4"></feather-icon> <span class="ml-2">Profilo</span></li>
                <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="printManuale"><feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4"></feather-icon> <span class="ml-2">Manuale</span></li>
                <li v-if="checkIfAdminMain" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="requestCSVImport($event)"><feather-icon icon="LoaderIcon" svgClasses="w-4 h-4"></feather-icon> <span class="ml-2">Import CSV: personale e insoluti</span></li>
                <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push({ name: 'faq' })"><feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4"></feather-icon> <span class="ml-2">FAQ</span></li> -->
                <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="openTodo"><feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4"></feather-icon> <span class="ml-2">To do</span></li> -->
                <vs-divider class="m-1"></vs-divider>
                <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logOut"><feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"></feather-icon> <span class="ml-2">Esci</span></li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </vs-navbar>
    </div>

    <vs-sidebar click-not-close position-right parent="body" color="primary" class="sidebarx sidebarpage sidebar-utenti" spacer v-model="profilo_aperto">
      <sidebar-profilo @close-me="sidebarClose" v-if="profilo_aperto" :selected="_.cloneDeep(utente)"></sidebar-profilo>
      <sidebar-form-utenti @close-me="sidebarClose" v-if="modifica_utente" @utente-salvato="modifica_utente = false" :selected="_.cloneDeep(utente)"></sidebar-form-utenti>
    </vs-sidebar>

    <vs-sidebar click-not-close position-right parent="body" color="primary" class="sidebarx sidebarpage sidebar-aziende" spacer v-model="todo_aperto">
      <sidebar-todo @close-me="sidebarClose" v-if="todo_aperto" :selected="_.cloneDeep(utente)"></sidebar-todo>
    </vs-sidebar>
  </div>
</template>

<script>
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue';
import draggable from 'vuedraggable'
import SidebarFormUtenti from '../../views/utente/SidebarFormUtenti.vue'
import SidebarProfilo from '../../views/utente/SidebarProfilo.vue'
import SidebarTodo from '../../views/utente/SidebarTodo.vue'
import axios from 'axios'
import Notifications from './Notifications.vue'

export default {
    name: "the-navbar",
    props: {
        navbarColor: {
            type: String,
            default: "#fff",
        },
    },
    data() {
        return {
            notifications: null,
            utente: null,
            profilo_aperto: false,
            todo_aperto: false,
            modifica_utente: false,
            navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
            searchQuery: '',
            showFullSearch: false,
            autoFocusSearch: false,
            showBookmarkPagesDropdown: false,
            u_name: "",
            u_cognome: "",
            u_mail: "",
        }
    },
    watch: {
        '$route'() {
            if (this.showBookmarkPagesDropdown) this.showBookmarkPagesDropdown = false
        }
    },
    computed: {
        // HELPER
        sidebarWidth() {
            return this.$store.state.sidebarWidth;
        },
        breakpoint() {
            return this.$store.state.breakpoint;
        },

        // NAVBAR STYLE
        classObj() {
            if (this.sidebarWidth == "default") return "navbar-default"
            else if (this.sidebarWidth == "reduced") return "navbar-reduced"
            else if (this.sidebarWidth) return "navbar-full"
        },

        // BOOKMARK & SEARCH
        data() {
            return this.$store.state.navbarSearchAndPinList;
        },
        starredPages() {
            return this.$store.state.starredPages;
        },
        starredPagesLimited: {
            get() {
                return this.starredPages.slice(0, 10);
            },
            set(list) {
                this.$store.dispatch('arrangeStarredPagesLimited', list);
            }
        },
        starredPagesMore: {
            get() {
                return this.starredPages.slice(10);
            },
            set(list) {
                this.$store.dispatch('arrangeStarredPagesMore', list);
            }
        },

        // PROFILE
        user_displayName() {
            return "john_doe"
            // return JSON.parse(localStorage.getItem('userInfo')).displayName
        },
        activeUserImg() {
            return ""
            // return JSON.parse(localStorage.getItem('userInfo')).photoURL || this.$store.state.AppActiveUser.img;
        },
        checkIfAdminMain() {
            if (localStorage.utente_mail == 'test@test.com') return true
            else return false
        }
    },
    methods: {
        clickProfile() {
          this.profilo_aperto = true
        },
        async printManuale() {
            this.activeLoading = true
            this.$vs.loading({
                type:'radius',
            })
            let p_to_print = _.cloneDeep(this.selected)
            p_to_print = await this.$tariffe.generatePDFazienda(p_to_print)

            axios.post(process.env.VUE_APP_BACKEND_API+'/tariffa_servizio/template', {
                nuovo_nome: "crm_manuale.pdf"
            },{
                headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
                responseType: 'blob'
            })
            .then( response => {
                const url = window.URL.createObjectURL(new Blob([response.data], {type:'application/octet-stream'}));
                const link = document.createElement('a');
                link.href = url
                this.$vs.loading.close()
                link.setAttribute('download', `Manuale - CRM .pdf`);
                document.body.appendChild(link);
                link.click();
            }
            ).catch(e => {
                this.$vs.notify({
                color: 'warning',
                time: 4000,
                title: 'Errore Template',
                text: 'riscontrati problemi con il template Manuale'
                })
                // console.log(e)
                this.$vs.loading.close()
            })
        },
        requestCSVImport(ev) {
        axios.get(process.env.VUE_APP_BACKEND_API+'/azienda/resultImportCsv',{
            headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
            withCredentials: true,
        }).then((response,error) => {
            if (response) {
            // console.log(response)
            this.$vs.notify({
                color: 'success',
                time: 4000,
                title: '',
                text: 'Import CSV avviato...'
            })
            } else {
            console.warn(error)
            this.$vs.notify({
                color: 'warning',
                time: 4000,
                title: 'Errore',
                text: error
            })
            }
        }).catch(e => { console.log(e) })
        if (ev) ev.stopPropagation()
        },
        openTodo() {
          this.$router.push({ name: 'to-do' })
          // this.todo_aperto = true
        },
        toggleTour() {
          axios.post(process.env.VUE_APP_BACKEND_API+'/utente/tour', {tour: true}, {
              headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json', },
              withCredentials: true,
          }) .then(response => {
              console.log(response.data)
              setTimeout(() => this.$tours['dashboardTour'].start(), 1000);
              localStorage['utente_tour'] = response.data.tour
          })
          .catch(e => console.log(e))
        },
        refreshUtente () {
            axios.post(process.env.VUE_APP_BACKEND_API+'/utente', {
                id: +localStorage.utente_id
            }, {
                headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json', },
                withCredentials: true,
            }) .then(response => {
                this.utente = response.data
            })
            .catch(e => console.log(e))
        },
        showSidebar() {
            this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
        },
        selected(item) {
            this.$router.push(item.url)
            this.showFullSearch = false;
        },
        actionClicked(item) {
            // e.stopPropogation();
            this.$store.dispatch('updateStarredPage', { index: item.index, val: !item.highlightAction });
        },
        showNavbarSearch() {
            this.showFullSearch = true;
        },
        showSearchbar() {
            this.showFullSearch = true;
        },
        outside: function() {
            this.showBookmarkPagesDropdown = false
        },
        logOut() {
            // console.log(this.$cookies)
            this.$cookies.remove('payload')
            this.$cookies.remove('signature')
            // console.log(this.$cookies)
            localStorage.clear()
            // https://stackoverflow.com/questions/66562225/vuex-state-reset-function-undefined
            // this.$store.getDefaultState()

            this.$router.push('/pages/login')
        },
        sidebarClose() {
          this.selected = null
          this.profilo_aperto = false
        }
    },
    directives: {
        'click-outside': {
            bind: function(el, binding) {
                const bubble = binding.modifiers.bubble
                const handler = (e) => {
                    if (bubble || (!el.contains(e.target) && el !== e.target)) {
                        binding.value(e)
                    }
                }
                el.__vueClickOutside__ = handler
                document.addEventListener('click', handler)
            },

            unbind: function(el) {
                document.removeEventListener('click', el.__vueClickOutside__)
                el.__vueClickOutside__ = null

            }
        }
    },
    components: {
        VxAutoSuggest,
        draggable,
        SidebarFormUtenti,
        Notifications,
        SidebarProfilo,
        SidebarTodo,
    },
    mounted() {
        this.refreshUtente()
        if (localStorage.utente_nome) {
            this.u_name = localStorage.utente_nome;
            this.u_cognome = localStorage.utente_cognome;
            this.u_mail = localStorage.utente_mail;
        }
    },
}
</script>
